import React from 'react';
import { Label } from '../../ui/label';
import { newSelect as NewSelect } from '../../ui/newSelect';
import { AGREEMENT_OPTIONS, STATUS_OPTIONS } from './partnersListFilters';

/**
 * Agreement + firm-status dropdowns for Programme / Portfolio (shareable via query params).
 */
const PartnersFilterBar = ({ agreement, status, onChange, className = '' }) => (
  <div className={`flex flex-wrap gap-4 items-end ${className}`}>
    <div className='w-56'>
      <Label className='mb-1 block text-xs text-muted-foreground'>Agreement</Label>
      <NewSelect
        options={AGREEMENT_OPTIONS}
        value={agreement || 'all'}
        onChange={(v) => onChange?.({ agreement: v || 'all', status })}
        placeholder='Agreement'
        clearable={false}
      />
    </div>
    <div className='w-48'>
      <Label className='mb-1 block text-xs text-muted-foreground'>Firm status</Label>
      <NewSelect
        options={STATUS_OPTIONS}
        value={status || 'active'}
        onChange={(v) => onChange?.({ agreement, status: v || 'active' })}
        placeholder='Firm status'
        clearable={false}
      />
    </div>
  </div>
);

export default PartnersFilterBar;
